/* global bodymovin */
window.addEventListener('load', () => {
    const fwcSection = document.querySelectorAll('.full-width-cta-section');

    fwcSection.forEach(section => {
        const fwpbgAnim = section.querySelector('.bg-animation-json');
        if (!fwpbgAnim) { return; }

        const dataJson = fwpbgAnim.getAttribute('data-json');
        let animationLoaded = false;

        function loadfwpbgAnim(elem, jsonPath) {
            const animate = bodymovin.loadAnimation({
                container: elem,
                path: jsonPath,
                renderer: 'svg',
                loop: false,
                autoplay: true,
            });
            animate.setSpeed(1.5);
        }

        // If the element is already visible (e.g. top of page), AOS might already have added the class
        if (fwpbgAnim.classList.contains('aos-animate') && !animationLoaded) {
            loadfwpbgAnim(fwpbgAnim, dataJson);
            animationLoaded = true;
            return;
        }

        // Watch for class changes (when aos-animate gets added)
        const observer = new MutationObserver(() => {
            if (fwpbgAnim.classList.contains('aos-animate') && !animationLoaded) {
                loadfwpbgAnim(fwpbgAnim, dataJson);
                animationLoaded = true;
                observer.disconnect(); // Stop watching
            }
        });

        observer.observe(fwpbgAnim, {
            attributes: true,
            attributeFilter: ['class'],
        });
    });
});
